module.exports = __webpack_public_path__ + "assets/images/croma_037f2087ba0bcbf8b61f3c7ad63c1822.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dialog-ballons/profiles/croma.png
// module id = 139
// module chunks = 0